import { render, staticRenderFns } from "./UserAvatarWithName.vue?vue&type=template&id=480af3e6&scoped=true&"
import script from "./UserAvatarWithName.vue?vue&type=script&lang=js&"
export * from "./UserAvatarWithName.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarWithName.vue?vue&type=style&index=0&id=480af3e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480af3e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480af3e6')) {
      api.createRecord('480af3e6', component.options)
    } else {
      api.reload('480af3e6', component.options)
    }
    module.hot.accept("./UserAvatarWithName.vue?vue&type=template&id=480af3e6&scoped=true&", function () {
      api.rerender('480af3e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/UserAvatarWithName.vue"
export default component.exports